import styled from '@emotion/styled';

export const Title = styled.h1`
  margin: 0;
  padding: 15px;
  border: 1px solid black;
  width: 100%;

  border-radius: 4px;

  font-weight: 700;
  font-size: 24px;
  line-height: 1.19;
  text-align: center;
  letter-spacing: 0.03em;

  color: black;
`;
